import React, { useCallback } from 'react';
import {
  ModalFloatingCloseBtn,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import type { CreditCardForm } from '@order/components';
import { PageWrapper, TransparentModal } from '@order/components';

import { useNavigateBack } from '../../navigation';
import { SweetpassPaymentMethodAddScreenContent } from './SweetpassPaymentMethodAddScreenContent';
import { usePaymentMethodToken } from './usePaymentMethodToken';
import { useSweetpassPaymentMethodAdd } from './useSweetpassPaymentMethodAdd';

export const SweetpassPaymentMethodAddScreen = () => {
  const { isMobile } = useBreakpointHelpers();

  const {
    isSweetpassEnabled,
    isLoading: isAdding,
    addPaymentMethod,
  } = useSweetpassPaymentMethodAdd();

  const { savePaymentMethodToken } = usePaymentMethodToken();

  const navigateBack = useNavigateBack();

  const handleSavePaymentMethod = useCallback(
    async (_form: CreditCardForm, nonce: string) => {
      const token = await addPaymentMethod(nonce);

      if (!token) return;

      await savePaymentMethodToken(token);

      navigateBack();
    },
    [addPaymentMethod, savePaymentMethodToken, navigateBack],
  );

  return (
    <TransparentModal size="xsmall" onClose={navigateBack}>
      {isMobile ? null : <ModalFloatingCloseBtn onPress={navigateBack} />}
      <PageWrapper
        withoutFooter
        testID="sweetpass-membership.payment-method-add.root.container"
      >
        {isSweetpassEnabled ? (
          <SweetpassPaymentMethodAddScreenContent
            testID="sweetpass-membership.payment-method-add"
            isAdding={isAdding}
            onSave={handleSavePaymentMethod}
          />
        ) : null}
      </PageWrapper>
    </TransparentModal>
  );
};
